import { render, staticRenderFns } from "./WhatsAppLocationShare.vue?vue&type=template&id=3afe50dc&"
import script from "./WhatsAppLocationShare.vue?vue&type=script&lang=js&"
export * from "./WhatsAppLocationShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports